<div class="container">
    <ng-container *ngFor="let group of listGroups">
        <p class="title" *ngIf="group.title">{{group.title}}</p>
        <ul class="list">
            <li *ngFor="let item of group.list">{{item}}</li>
        </ul>
    </ng-container>
</div>
